import BENEFIT from 'core/data-model/constants/bi-rider'

export const getApEcareExceptionNotes = (riderCodes) => {
  let noted = { ...BENEFIT.EXCEPTION_NOTED_AP_ECARE }
  noted.condition = noted.condition + (riderCodes.length === 1 ? riderCodes[0] : BENEFIT.RIDER_AP_ECARE_NAME)
  return noted
}

export const getHICExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_HIC
}

export const getCPRExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_CPR
}

export const getMEAPlusExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MEAPLUS
}

export const getMEXExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MEX
}

export const getMEHExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MEH
}

export const getFHExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_FH
}

export const getMEBExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MEB
}

export const getMEBExceptionNotes17 = () => {
  return BENEFIT.EXCEPTION_NOTED_MEB_17
}

export const getMEKExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MEK
}

export const getMHPExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MHP
}

export const getMCIExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_MCI
}

export const getMCIExplanationNotes = () => {
  return BENEFIT.EXPLANATION_NOTED_MCI
}

export const getCIESExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_CIES
}

export const getCIESExplanationNotes = () => {
  return BENEFIT.EXPLANATION_NOTED_CIES
}

export const getCIESDiseaseNotes = () => {
  return BENEFIT.DISEASE_NOTED_CIES
}

export const getCIESDiseaseAdditionalNotes = () => {
  return BENEFIT.DISEASE_ADDITIONAL_NOTED_CIES
}

export const getMEHExceptionNotes32 = () => {
  return BENEFIT.EXCEPTION_NOTED_MEH_32
}

export const getESCIExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_ESCI
}

export const getWPEExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_WPE
}

export const getDCIExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_DCI
}

export const getPBPDDExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_PBPDD_PBSDD
}

export const getPBSDDExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_PBPDD_PBSDD
}

export const getPBPDDCIExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_PBPDDCI_PBSDDCI
}

export const getPBSDDCIExceptionNotes = () => {
  return BENEFIT.EXCEPTION_NOTED_PBPDDCI_PBSDDCI
}
